import { BaseModal, ModalResultType } from "../../modal/index";
import { Template, LazyTemplate } from "../../template/index";

export default class MessageModal extends BaseModal
{
    public template = Template.lazy('/core/modals/message/index.html');

    constructor(message = '', title = 'Confirmation')
    {
        super(title, message);
    }

    public beforeRender(): PromiseLike<void>
    {
        return super.beforeRender();
    }

    public onOkButtonClick(e: MouseEvent)
    {
        this.close(ModalResultType.OK);
    }
}